/** @format */

import {Box} from '@mui/material';

import {platformIconSrc} from 'helpers/imageHelpers';
import type {PlatformWithAll} from 'types';

type Props = {
  bw?: boolean;
  platforms: PlatformWithAll[];
  size?: number;
};

const Platforms = (props: Props) => {
  const {bw = false, size = 40} = props;

  return (
    <Box
      sx={{
        display: 'flex',
      }}
    >
      {props.platforms.map((v, i) => (
        <Box
          key={i}
          sx={{
            alignItems: 'center',
            display: 'flex',
            mr: 2,
          }}
        >
          <img alt='Icon' height={size} src={platformIconSrc(v, size, bw)} width={size} />
        </Box>
      ))}
    </Box>
  );
};

export default Platforms;
